import { useState, useEffect } from 'react';

import axios from 'axios';
import routes from 'app/routes';

export default function useBusinessSizes() {
  const [loading, setLoading] = useState(true);
  const [businessSizes, setBusinessSizes] = useState([]);

  useEffect(() => {
    axios
      .get(routes.api.business_sizes.index)
      .then((response) => {
        setBusinessSizes(response.data.data);
        setLoading(false);
      });
  }, []);

  return { loading, businessSizes };
}
